// A satellite sells what its hub sells (owner's decision 2026-10-29). A satellite branch takes cargo
// in for its parent hub, so by default it offers the hub's box sizes and prices with the hub's
// cards. It can still have its own: a card made for the satellite itself comes first, and a box
// size that lists the satellite is offered there whatever the hub does.

/** The branches whose sizes and cards a branch sells, nearest first: itself, then its parent hub. */
export function offeringBranches(branch: {
  code: string;
  parentHubId?: string | undefined;
}): string[] {
  return branch.parentHubId && branch.parentHubId !== branch.code
    ? [branch.code, branch.parentHubId]
    : [branch.code];
}

/**
 * Whether a box size is offered at a branch: every branch when its list is empty, else when the
 * list names the branch or its parent hub.
 */
export function sizeOfferedAt(
  enabledBranchIds: readonly string[],
  branch: { code: string; parentHubId?: string | undefined },
): boolean {
  if (enabledBranchIds.length === 0) return true;
  return offeringBranches(branch).some((b) => enabledBranchIds.includes(b));
}
